const personOrder = [
  {
    id: 1,
    img: `https://picsum.photos/id/11/40/40`,
    person_name: "Toxir",
    order: "osh",
    pay: "$500",
    status: false,
  },
  {
    id: 2,
    img: `https://picsum.photos/id/12/40/40`,
    person_name: "Toxir",
    order: "osh qazili",
    pay: "$500",
    status: false,
  },
  {
    id: 3,
    img: `https://picsum.photos/id/13/40/40`,
    person_name: "Toxir",
    order: "qozon kabob",
    pay: "$500",
    status: false,
  },
  {
    id: 4,
    img: `https://picsum.photos/id/14/40/40`,
    person_name: "Toxir",
    order: "tandir kabob",
    pay: "$500",
    status: false,
  },
  {
    id: 5,
    img: `https://picsum.photos/id/15/40/40`,
    person_name: "Toxir",
    order: "moxora",
    pay: "$500",
    status: false,
  },
  {
    id: 6,
    img: `https://picsum.photos/id/16/40/40`,
    person_name: "Toxir",
    order: "manti",
    pay: "$500",
    status: false,
  },
  {
    id: 7,
    img: `https://picsum.photos/id/17/40/40`,
    person_name: "Toxir",
    order: "osh qazili",
    pay: "$500",
    status: false,
  },
  {
    id: 8,
    img: `https://picsum.photos/id/18/40/40`,
    person_name: "Toxir",
    order: "osh qazili",
    pay: "$500",
    status: false,
  },
  {
    id: 9,
    img: `https://picsum.photos/id/19/40/40`,
    person_name: "Toxir",
    order: "osh qazili",
    pay: "$500",
    status: false,
  },
  {
    id: 10,
    img: `https://picsum.photos/id/10/40/40`,
    person_name: "Toxir",
    order: "osh qazili",
    pay: "$500",
    status: false,
  },
];

export default personOrder;
